import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import congratsImg from '../../assets/congrats.jpg';
import logo from '../../assets/logo.png';
import styles from './CongratsScreen.module.css';

interface ApiResponse {
  status: string;
  user: {
    _id: string;
    fullName: string;
    email: string;
  };
  order: {
    _id: string;
    price: number;
    status: string;
  };
}

const CongratsScreen: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState<ApiResponse | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Get paymentIntentId from query params or state
  const params = new URLSearchParams(location.search);
  const paymentIntentId = params.get('payment_intent') || (location.state && location.state.paymentIntentId);
  const redirectStatus = params.get('redirect_status');

  useEffect(() => {
    // Get previous paymentIntentId from localStorage
    const prevPaymentIntentId = localStorage.getItem('paymentIntentId');
    // If paymentIntentId changed, clear previous data
    if (prevPaymentIntentId && prevPaymentIntentId !== paymentIntentId) {
      localStorage.removeItem('paymentConfirmed');
      localStorage.removeItem('user');
      localStorage.removeItem('order');
    }
    // Save current paymentIntentId
    if (paymentIntentId) {
      localStorage.setItem('paymentIntentId', paymentIntentId);
    }

    // Check if payment already confirmed in localStorage
    const confirmed = localStorage.getItem('paymentConfirmed');
    if (confirmed && paymentIntentId) {
      const user = localStorage.getItem('user');
      const order = localStorage.getItem('order');
      if (user && order) {
        setData({
          status: 'succeeded',
          user: JSON.parse(user),
          order: JSON.parse(order),
        });
        setLoading(false);
        return;
      }
    }

    const confirmPayment = async () => {
      if (redirectStatus !== 'succeeded') {
        setError('Payment was not successful. Please try again or contact support.');
        setLoading(false);
        return;
      }
      if (!paymentIntentId) {
        setError('No payment reference found.');
        setLoading(false);
        return;
      }
      try {
        const res = await fetch('https://nova-media-backend.vercel.app/api/stripe/confirm', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ paymentIntentId }),
        });
        const json = await res.json();
        console.log(json,'...json')
        if (json.status === 'success' || json.status === 'succeeded') {
          setData(json);
          localStorage.setItem('user', JSON.stringify({
            ...json.user,
            status: 'succeeded'
          }));
          localStorage.setItem('order', JSON.stringify(json.order));
          localStorage.setItem('paymentConfirmed', 'true'); // Set flag
        } else {
          setError('Payment not successful. Please contact support if you were charged.');
        }
      } catch (err) {
        setError('Something went wrong. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    confirmPayment();
  }, [paymentIntentId, redirectStatus]);
console.log(data,'...data')
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={logo} alt="Logo" className={styles.logo} />
        <img src={congratsImg} alt="Congratulations" className={styles.congratsImg} />
        <h2 className={styles.heading}>Congratulations!</h2>
        {loading ? (
          <div className={styles.loading}>Processing your payment...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : data ? (
          <>
            <div className={styles.message}>
              Thank you <b>{data.user.fullName}</b>!<br />
              Your payment of <b>£{(data.order.price / 100).toFixed(2)}</b> was successful.<br />
              You now have access to your purchased courses.
            </div>
           
          </>
        ) : null}
        <button
          className={styles.button}
          disabled={loading || Boolean(error) || !data || data.order.status !== 'succeeded'}
          onClick={() => navigate('/course-video')}
        >
          Go to Courses
        </button>
      </div>
    </div>
  );
};

export default CongratsScreen; 